<div tabindex="0" class="busqueda-general" *ngIf="isMiniGrid == true">
    <!-- <mat-form-field > -->
    <!-- <mat-label>{{ "SEARCH" | translate }}</mat-label> -->
    <input class="general-search-field" matInput (focus)="setDefaultFilter()" (keyup)="applyFilter($event)"
        placeholder="{{ 'SEARCH' | translate }}" #input>
    <!-- </mat-form-field>       -->
</div>
<div class="grid-container">
    <hr class="divider" [ngClass]="{
        'divider-normal': isMiniGrid == false,
        'divider-mini-grid': isMiniGrid == true
    }">
    <div class="grid-title-container" [ngClass]="{
        'grid-title-container-border-bottom': isMiniGrid == false
    }">
        <span class="grid-title">{{ title | translate }}</span>
        <div class="button-area">
            <span class="unchanged-button" (click)="SAVE_CHANGES()" *ngIf="UnchangedChanges() > 0">{{ "SAVE_CHANGES" | translate }}</span>
            <button id="btn-grid-menu" mat-icon-button [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
    </div>
    <mat-menu #menu="matMenu">
        <button *ngIf="isMiniGrid == false && showFilterButton == true" mat-menu-item (click)="ToggleFilters()">
            <mat-icon>filter_list</mat-icon>
            <span *ngIf="showFilters == false">{{ "SHOW_FILTER" | translate }}</span>
            <span *ngIf="showFilters == true">{{ "HIDE_FILTER" | translate }}</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="export">
            <mat-icon>download</mat-icon>
            <span>{{ "DOWNLOAD" | translate }}</span>
        </button>
        <button *ngIf="isMiniGrid == false" mat-menu-item [matMenuTriggerFor]="columnas">
            <mat-icon>view_column</mat-icon>
            <span>{{"COLUMNS" | translate}}</span>
        </button>
    </mat-menu>
    <mat-menu class="grid" id="menu" #columnas="matMenu" yPosition="below">
        <div [formGroup]="checkColumns" class="menu-container" (cdkDropListSorted)="onSorted($event)" cdkDropList
            [cdkDropListData]="columns">
            <mat-checkbox formControlName="{{column.nombre}}" cdkDrag *ngFor="let column of columns"
                (click)="$event.stopPropagation();">
                {{ column.nombre | translate }}
            </mat-checkbox>
        </div>
    </mat-menu>
    <mat-menu class="grid" #export="matMenu" yPosition="below">
        <button (click)="exportAsExcel()" mat-menu-item>
            <mat-icon>download</mat-icon>
            <span>Excel</span>
        </button>
        <button (click)="exportAsCsv()" mat-menu-item>
            <mat-icon>download</mat-icon>
            <span>Csv</span>
        </button>
    </mat-menu>
    <div id="grid" tabindex="0" #gridContainer>
        <table #grid mat-table [dataSource]="dataSource" matTableExporter matSort multiTemplateDataRows>
            <ng-container *ngFor="let column of columns" matColumnDef="{{column.nombre}}">
                <th [ngClass]="{
                        'mini-grid-header': isMiniGrid == true,
                        'grid-header': isMiniGrid == false
                    }" mat-header-cell *matHeaderCellDef>

                    <!--Normal column-->
                    <span *ngIf="column.nombre !== CHECK_BOX_COLUMN_NAME" class="column-header-title">
                        <span mat-sort-header *ngIf="isMiniGrid == false">{{column.nombre | translate }}</span>
                    </span>

                    <!--Select Column-->
                    <input (click)="$event.stopPropagation()" *ngIf="
                        isMiniGrid == false && 
                        column.nombre !== CHECK_BOX_COLUMN_NAME && 
                        isListColumn(column.nombre) == false && 
                        isMultiColumnIconColumn(column.nombre) == false &&
                        showFilters == true" class="input-control-filter" (keyup)="applyFilter(column.nombre, $event)"
                        matInput placeholder="{{ 'FILTER' | translate }}" #input>

                    <div class="grid-select"
                        *ngIf="isMiniGrid == false && column.nombre !== CHECK_BOX_COLUMN_NAME && isListColumn(column.nombre) == true && showFilters == true">
                        <mat-select (click)="$event.stopPropagation()" [(value)]="selectedValues[column.nombre]"
                            class="mat-select-style" (focus)="setupFilter(column.nombre)"
                            (selectionChange)="optionChange(column.nombre, $event)">
                            <mat-option class="mat-option-style" value="All">All</mat-option>
                            <!-- <mat-option class="mat-option-style" *ngFor="let item of getColumnValues(column.nombre)" value="{{item.value}}">{{ item.value }}</mat-option> -->
                            <mat-option class="mat-option-style"
                                *ngFor="let item of GetColumnFilterValues(column.nombre)" value="{{item.value}}">{{
                                item.value }}</mat-option>
                        </mat-select>
                    </div>

                    <!--CheckBox Column-->
                    <div class="check-box--container">
                        <mat-checkbox (click)="$event.stopPropagation()" *ngIf="column.nombre == CHECK_BOX_COLUMN_NAME"
                            (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                    </div>

                    <!--MultiIcons Column-->
                    <div *ngIf="
                        isMiniGrid == false && 
                        column.nombre !== CHECK_BOX_COLUMN_NAME && 
                        isListColumn(column.nombre) == false && 
                        isMultiColumnIconColumn(column.nombre) == true &&
                        showFilters == true" class="multi-icon-header">
                        <!---->
                        <mat-button-toggle-group (change)="onToggleChange(column.nombre, $event)" appearance="legacy"
                            name="fontStyle" aria-label="Font Style" shape="None"
                            [hideMultipleSelectionIndicator]="true" multiple>
                            <mat-button-toggle (click)="$event.stopPropagation()"
                                *ngFor="let filterValue of GetColumnFilterValues(column.nombre)"
                                value="{{filterValue.value}}">
                                <span class="multi-column-icon--icon"
                                    [ngStyle]="{'background-image': 'url(' + filterValue.icon + ')'}"></span>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </th>
                <td mat-cell [ngClass]="{
                    'column-test': clicRowId == element.ROW_ID,
                }" class="column-test" *matCellDef="let element" (mousedown)="cellClick($event,element)"
                    (mousedown)="$event.preventDefault()">
                    <!--Normal column-->
                    <div
                        *ngIf="isMiniGrid == false && column.nombre !== CHECK_BOX_COLUMN_NAME && !IsActioncolumn(column.nombre) && !IsColumnGridSource(column.nombre)">
                        <div *ngIf="column.nombre == iconColumn.IconColumnName && !multiIconColumnString.includes(column.nombre)"
                            class="mat-cell-content column-w-icon">
                            <!--  -->
                            <span
                                class="column-icon--box column-icon-{{element[iconColumn.IconValue].toString()}}"></span>
                            {{ ColumnValue(column.nombre, element[column.nombre]) }}
                        </div>
                        <span class="my-cell-content"
                            *ngIf="column.nombre !== iconColumn.IconColumnName && !multiIconColumnString.includes(column.nombre)">{{
                            ColumnValue(column.nombre, element[column.nombre]) }}</span>

                        <div class="multi-column-icon" *ngIf="multiIconColumnString.includes(column.nombre)">
                            <span class="multi-column-icon--icon" [ngStyle]="{
                                'background-image': 'url(' + icon.icon + ')'
                            }" *ngFor="let icon of icons(column.nombre, element[column.nombre])">

                            </span>
                        </div>
                    </div>

                    <!--Column source-->
                    <div
                        *ngIf="isMiniGrid == false && column.nombre !== CHECK_BOX_COLUMN_NAME && !IsActioncolumn(column.nombre) && IsColumnGridSource(column.nombre)">

                        <mat-select (click)="$event.stopPropagation()"
                            [value]="ShowSourceValue(column.nombre, element)?.Id"
                            (selectionChange)="onSourceValueChanged($event.value, column.nombre, element)">
                           
                           
                           
                             <mat-select-trigger>
                                <div class="option-container">
                                <div class="primary-text">{{ ShowSourceValue(column.nombre, element)?.Description }}</div>
                                <div class="secondary-text">{{ ShowSourceValue(column.nombre, element)?.ExtraDescription1 }}</div>
                                <div class="secondary-text">{{ ShowSourceValue(column.nombre, element)?.ExtraDescription2 }}</div>
                                </div>
                            </mat-select-trigger>

                           
                            <mat-option *ngFor="let item of GetSourceValues(column.nombre)" [value]="item.Id">
                                <div class="option-container">
                                    <span class="primary-text">{{ item.Description }}</span>
                                    <span class="secondary-text">{{ item.ExtraDescription1 }}</span>
                                    <span class="secondary-text">{{ item.ExtraDescription2 }}</span>
                                </div>
                            </mat-option>
                        </mat-select>
                    </div>

                    <!--Mini grid column-->
                    <div *ngIf="isMiniGrid == true" class="responsive-row-content">
                        <div class="responsive-row" *ngFor="let responsibleColumn of responsibleShowColumns">
                            <span class="responsive-column--title">
                                {{responsibleColumn.nombre | translate }}
                            </span>
                            <span class="responsive-column--content">
                                <span
                                    *ngIf="responsibleColumn.isMainColumn == true && !multiIconColumnString.includes(responsibleColumn.nombre)"
                                    class="main-column column-w-icon">
                                    <span
                                        class="column-icon--box column-icon-{{element[iconColumn.IconValue].toString()}}"></span>
                                    {{ ColumnValue(responsibleColumn.nombre, element[responsibleColumn.nombre]) }}
                                </span>
                                <span
                                    *ngIf="responsibleColumn.isMainColumn == false && !multiIconColumnString.includes(responsibleColumn.nombre)">
                                    {{ ColumnValue(responsibleColumn.nombre, element[responsibleColumn.nombre]) }}
                                </span>
                                <span class="multi-column-icon--box"
                                    *ngIf="multiIconColumnString.includes(responsibleColumn.nombre)">
                                    <span class="multi-column-icon--icon" [ngStyle]="{
                                        'background-image': 'url(' + icon.icon + ')'
                                    }"
                                        *ngFor="let icon of icons(responsibleColumn.nombre, element[responsibleColumn.nombre])"></span>
                                </span>
                            </span>
                        </div>
                    </div>

                    <!--CheckBox Column-->
                    <div *ngIf="isMiniGrid == false && column.nombre == CHECK_BOX_COLUMN_NAME"
                        class="check-box--container">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(element) : null"
                            [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                        </mat-checkbox>
                    </div>

                    <!--Action column-->
                    <div *ngIf="isMiniGrid == false && column.nombre == this.actionColumn.ColumnName && IsActioncolumn(column.nombre)"
                        class="action-column--container">
                        <span class="grid-action" *ngFor="let action of this.actionColumn.Actions"
                            [style.background-image]="'url(' + GetActionIconURL(element, action) + ')'"
                            (mousedown)="cellClick($event, element, action)"></span>
                    </div>
                </td>
            </ng-container>

            <tr [ngClass]="{
                'mini-grid-header-row': isMiniGrid == true
            }" mat-header-row *matHeaderRowDef="_displayedColumns()"></tr>
            <tr class="element-row" mat-row *matRowDef="let row; columns: _displayedColumns()"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{ "NO_DATA_DESCRIPTION" | translate }}</td>
            </tr>
        </table>
        <!-- Fila fuera de la tabla -->
        <div *ngIf="ShowAddButton == true" class="add-row" style="padding: 12px; text-align: center;">
            <button class="plus-button" (click)="ADD($event)">+</button>
        </div>
    </div>
    <mat-paginator id="paginator" [pageSizeOptions]="[10, 20, 50, 75, 100]"
        aria-label="Select page of users"></mat-paginator>
</div>